import { useGlobal } from 'hooks/useGlobal';
import { ReadOnlyDialog } from '@/components/ErrorDialogs/ReadOnlyDialog';
import type { ApiError } from '@/components/ErrorDialogs';

/**
 * Shows the read-only dialog when the API refuses a write with 402 (an account
 * with no active plan, see billing-write-guard.ts). `useClient` stores every API
 * error under the global `API_ERROR`; this reads it for that one status.
 *
 * Deliberately not the whole `ErrorDialogs` component: nothing mounts that today, so
 * its 401, 403 and 5xx dialogs are not live, and turning them all on as a side effect
 * of this change would be a behaviour change nobody asked for. Screens whose hooks
 * already toast the server's message keep doing so; this catches the ones that do not.
 */
export const ReadOnlyNotice = () => {
  const [apiError, setApiError] = useGlobal<ApiError | null>('API_ERROR', null);
  if (apiError?.status !== 402) return null;
  return <ReadOnlyDialog apiError={apiError} setApiError={setApiError} />;
};
